// Google Analytics utilities (GA4). gtag is loaded in public/index.html.

export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-Y57SMHTQV0';

const gtagEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

export const trackEvent = (eventName, eventParams = {}) => {
  gtagEvent(eventName, eventParams);
};

export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

/** Primary register button / link (hero, nav, footer, etc.) */
export const trackCtaClick = (action, location) => {
  gtagEvent('cta_click', {
    cta_action: action,
    cta_location: location,
  });
};

export const trackRegisterStarted = () => {
  gtagEvent('register_started');
};

export const trackGatewayInstall = (source) => {
  gtagEvent('gateway_install_started', {
    install_path: source,
  });
};

export const trackBetaInterest = (channel = 'mailto') => {
  gtagEvent('beta_interest', {
    contact_channel: channel,
  });
};

export const trackGatewayRegistration = () => {
  gtagEvent('gateway_registered');
};

export const trackLogin = (method = 'email') => {
  gtagEvent('login', { method });
};

export const trackSignup = (method = 'email') => {
  gtagEvent('sign_up', { method });
};

/** @deprecated use trackBetaInterest */
export const trackBetaSignup = trackBetaInterest;
